import { HTTPStatusCode } from "@libs/api/types";
import { tsRestClient } from "@/services/ts-rest";
import { logger } from "@/utils/logger";

export const ClinicsApi = {
  listClinics: async () => {
    const res = await tsRestClient().patients.listClinics();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to list clinics",
      shouldThrowError: true,
    });
  },
};
